<template>
  <v-container>
    <v-tab-item class="pb-0" eager>
      <div class="display-1 font-weight-normal mb-6 text-center">Selecione o mês e versão que serão importados</div>
      <first-tab-content
        :itemsTable="itemsTableFirstTab"
        :selectedItem.sync="selectedItemFirstTab"
        :loading.sync="loadingFirstTab"
        @stepReleased="$emit('stepReleased', $event)"
      />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <div class="display-1 font-weight-normal mb-6 text-center">Selecione as entidades que serão importadas</div>
      <second-tab-content
        :itemsTable="itemsTableSecondTab"
        :selectedItem.sync="selectedItemSecondTab"
        :loading.sync="loadingSecondTab"
        :relevantEntities="relevantEntities"
        :ancillaryEntities="ancillaryEntities"
        @stepReleased="$emit('stepReleased', $event)"
      />
    </v-tab-item>
  </v-container>
</template>

<script>
  import Firestore from '@/Firestore.js';
  import HexaMapsService from '@/services/HexaMapsService.js';

  export default {
    components: {
      FirstTabContent: () => import('@/components/importacoesBdgd/tabs/FirstTabContent.vue'),
      SecondTabContent: () => import('@/components/importacoesBdgd/tabs/SecondTabContent.vue')
    },
    props: {
      items: {
        type: Object,
        default: () => {}
      }
    },

    emits: ['stepReleased'],

    data() {
      return {
        loadingFirstTab: false,
        loadingSecondTab: false,
        itemsTableFirstTab: [],
        itemsTableSecondTab: [],
        selectedItemFirstTab: [],
        selectedItemSecondTab: [],
        counters: {},
        empresa: null,
        relevantEntities: [],
        ancillaryEntities: []
      };
    },

    mounted() {
      this.getEmpresa();
    },

    methods: {
      getEmpresa() {
        Firestore.collection('empresas')
          .doc(this.$store.getters.getIdEmpresaFirebase)
          .get()
          .then((doc) => (this.empresa = doc.data()));
      },

      fillFirstTab() {
        this.loadingFirstTab = true;

        const empresaId = this.empresa.hexa_maps_empresa_id;
        HexaMapsService.getBdgdsImportadas(empresaId)
          .then((response) => {
            this.itemsTableFirstTab = response.data.bases || [];
          })
          .finally(() => (this.loadingFirstTab = false));
      },

      fillSecondTab(selectedDate, bdgdVersionId) {
        this.loadingSecondTab = true;

        const companyId = this.empresa.hexa_maps_empresa_id;
        HexaMapsService.getEntidadesBdgdsImportadas(selectedDate, companyId, bdgdVersionId)
          .then((response) => {
            this.itemsTableSecondTab = response.data.entidades || [];
          })
          .catch(() => this.$emit('stepReleased', { numberStep: 1, available: false })) /* 1 == second tab */
          .finally(() => (this.loadingSecondTab = false));

        this.relevantEntities = HexaMapsService.getEntidadesBdgdsRelevantes();
        this.ancillaryEntities = HexaMapsService.getEntidadesBdgdsAcessorias();
      },

      exportData() {
        let arrTabelas = [];

        this.selectedItemSecondTab.forEach((item) => {
          arrTabelas.push(item.entidade);
        });

        return {
          empresa_id: this.empresa.hexa_maps_empresa_id,
          data_registro: this.selectedItemFirstTab[0].data_registro,
          versao: this.selectedItemFirstTab[0].versao,
          entidades: arrTabelas,
          contadores: this.counters,
          status: 'AGUARDANDO'
        };
      }
    },

    watch: {
      empresa() {
        if (this.empresa && this.empresa.hexa_maps && this.empresa.hexa_maps_empresa_id) {
          this.fillFirstTab();
        }
      },

      selectedItemFirstTab(arrNewVal) {
        let selectedDate = arrNewVal.length ? arrNewVal[0].data_registro : undefined;
        let bdgdVersionId = arrNewVal.length ? arrNewVal[0].bdgd_versao_id : undefined;

        if (selectedDate && bdgdVersionId) {
          this.fillSecondTab(selectedDate, bdgdVersionId);
        }
      },

      selectedItemSecondTab(arrNewVal) {
        let counters = {};

        if (arrNewVal.length) {
          arrNewVal.forEach((item) => {
            counters[item.entidade] = item.registros;
          });
        }

        this.counters = counters;
      }
    }
  };
</script>
